import React from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import apiClient from "../common/apiClient";
import Config from "../common/Config";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class DefinitiveReview extends Review {
  constructor(props) {
    super(props);

    this.nomodificationId = 154;
    this.transferAsIsId = 28;

    this.customerSuppliedFabricId = 22;
    this.customerSuppliedLockId = 43;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedValveId = 58;

    this.state = {
      uOM: null,
      mPTToFloor: null,
      calfToFloor: null,
      calfCirc: null,
      ankleCirc: null,
      iTToFloor: null,
      thighToFloor: null,
      kCToFloor: null,
      thighCirc: null,
      kCCirc: null,
      notes: null,
      linerInterface: null,
      linerSize: null,
      linerProfile: null,
      linerPartNumber: null,
      linerOptionCombinations: [],
      socketFinish: [],
      otherPRS: [],
      socketOption: [],
      insertMaterial: [],
      lock: [],
      lockType: [],
      valve: [],
      mountingPlate: [],
      prostheticHeight: [],
      shorten: [],
      extend: [],
      socketMaterial: [],
      lynOption: [],
      fredsLegsDesignName: [],
      revoFit: [],
      revoFitEnabled: null,
      additionalWindowQuantity: [],
      footType: null,
      footMaterial: null,
      footImpact: null,
      footPartNumber: null,
      includeFoot: null,
      includeLiner: null,
      linerQuantity: null,
      footShell: null,
      modification: [],
      modificationPercentage: [],
      modificationPly: [],
      cart: [],
      cadFileName: null,
      customerSuppliedPlate: null,
      customerSuppliedLock: null,
      customerSuppliedValve: null,
      customerSuppliedFabric: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      super.loadData();
    

      let fieldInputConfig = {
        headers: {},
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "calfToFloor",
            "calfCirc",
            "ankleCirc",
            "socketFinish",
            "otherPRS",
            "socketOption",
            "insertMaterial",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "linerInterface",
            "linerSize",
            "linerProfile",
            "prostheticHeight",
            "prostheticHeightUOM",
            "shorten",
            "extend",
            "iTToFloor",
            "thighToFloor",
            "kCToFloor",
            "thighCirc",
            "kCCirc",
            "socketMaterial",
            "AKLynValveOption",
            "fredsLegsDesignName",
            "additionalRevoFitWindows",
            "revoFit",
            "revoFitEnabled",
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "includeLiner",
            "linerQuantity",
            "footShell",
            "modification",
            "modificationPly",
            "modificationPercentage",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
            "customerSuppliedFabric",
          ],
        },
      };

      const config = { headers: {} };
      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await apiClient.get("fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      
      let footPartNumber = (
        await apiClient.get("footPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let linerPartNumber = (
        await apiClient.get("linerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      const cadFile = (
        await apiClient.get("cadFiles/" + this.props.formTypeId,
          config
        )
      ).data;
      
      const customerSuppliedPlate = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedPlate")?.stringData;
      const customerSuppliedLock = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedLock")?.stringData;
      const customerSuppliedValve = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedValve")?.stringData;
      const customerSuppliedFabric = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedFabric" && fi.stringData != null)?.stringData;

      this.setState({
        uOM: fieldInputs.find((fi) => fi.fieldName === "uOM")?.fieldOptionName,
        mPTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "mPTToFloor")?.numericData ??
          0,
        calfToFloor:
          fieldInputs.find((fi) => fi.fieldName === "calfToFloor")
            .numericData ?? 0,
        calfCirc:
          fieldInputs.find((fi) => fi.fieldName === "calfCirc")?.numericData ??
          0,
        ankleCirc:
          fieldInputs.find((fi) => fi.fieldName === "ankleCirc")?.numericData ??
          0,
        iTToFloor:
          fieldInputs.find((fi) => fi.fieldName === "iTToFloor")?.numericData ??
          0,
        thighToFloor:
          fieldInputs.find((fi) => fi.fieldName === "thighToFloor")?.numericData ?? 
          0,
        kCToFloor:
          fieldInputs.find((fi) => fi.fieldName === "kCToFloor")?.numericData ??
          0,
        thighCirc:
          fieldInputs.find((fi) => fi.fieldName === "thighCirc")?.numericData ??
          0,
        kCCirc:
          fieldInputs.find((fi) => fi.fieldName === "kCCirc")?.numericData ?? 0,
        socketFinish: fieldInputs.filter(
          (fi) => fi.fieldName === "socketFinish"
        ),
        otherPRS: fieldInputs.filter((fi) => fi.fieldName === "otherPRS"),
        socketOption: fieldInputs.filter(
          (fi) => fi.fieldName === "socketOption"
        ),
        insertMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "insertMaterial"
        ),
        lock: fieldInputs.filter((fi) => fi.fieldName === "lock"),
        lockType: fieldInputs.filter((fi) => fi.fieldName === "lockType"),
        valve: fieldInputs.filter((fi) => fi.fieldName === "valve"),
        mountingPlate: fieldInputs.filter(
          (fi) => fi.fieldName === "mountingPlate"
        ),
        prostheticHeight: fieldInputs.filter(
          (fi) => fi.fieldName === "prostheticHeight"
        ),
        prostheticHeightUOM: fieldInputs.filter(
          (fi) => fi.fieldName === "prostheticHeightUOM"
        ),
        shorten: fieldInputs.filter((fi) => fi.fieldName === "shorten"),
        extend: fieldInputs.filter((fi) => fi.fieldName === "extend"),
        socketMaterial: fieldInputs.filter(
          (fi) => fi.fieldName === "socketMaterial"
        ),
        lynOption: fieldInputs.filter(
          (fi) => fi.fieldName === "AKLynValveOption"
        ),
        fredsLegsDesignName: fieldInputs.filter(
          (fi) => fi.fieldName === "fredsLegsDesignName"
        ),
        revoFit: fieldInputs.filter((fi) => fi.fieldName === "revoFit"),
        revoFitEnabled: fieldInputs.find(
          (fi) => fi.fieldName === "revoFitEnabled"
        )?.booleanData,
        additionalWindowQuantity: fieldInputs.filter(
          (fi) => fi.fieldName === "additionalRevoFitWindows"
        ),
        linerSize: fieldInputs.find((fi) => fi.fieldName === "linerSize")?.fieldOptionName,
        linerProfile: fieldInputs.find((fi) => fi.fieldName === "linerProfile")?.fieldOptionName,
        linerInterface: fieldInputs.find((fi) => fi.fieldName === "linerInterface")?.fieldOptionName,
        linerPartNumber: linerPartNumber,
        footPartNumber: footPartNumber,
        footType: fieldInputs.find((fi) => fi.fieldName === "footType")?.fieldOptionName,
        footMaterial: fieldInputs.find((fi) => fi.fieldName === "footMaterial")?.fieldOptionName,
        footShell: fieldInputs.find((fi) => fi.fieldName === "footShell")?.fieldOptionName,
        footImpact: fieldInputs.find((fi) => fi.fieldName === "footImpact")?.fieldOptionName,
        linerQuantity:
          fieldInputs.find((fi) => fi.fieldName === "linerQuantity")?.numericData ??
          0,
        includeLiner: fieldInputs.find((fi) => fi.fieldName === "includeLiner")?.fieldOptionName === "Yes",
        includeFoot: fieldInputs.find((fi) => fi.fieldName === "includeFoot")?.fieldOptionName === "Yes",

        modification: fieldInputs.find((fi) => fi.fieldName === "modification"),
        modificationPercentage: fieldInputs.filter((fi) => fi.fieldName === "modificationPercentage"),
        modificationPly: fieldInputs.filter((fi) => fi.fieldName === "modificationPly"),
        
        customerSuppliedPlate: (customerSuppliedPlate === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedPlate,
        customerSuppliedLock: (customerSuppliedLock === "" || customerSuppliedLock === null) ? "No Value Entered" : customerSuppliedLock,
        customerSuppliedValve: (customerSuppliedValve === "" || customerSuppliedValve === null) ? "No Value Entered" : customerSuppliedValve,
        customerSuppliedFabric: (customerSuppliedFabric === "" || customerSuppliedFabric === null) ? "No Value Entered" : customerSuppliedFabric,

        cadFileName:  cadFile !== null ? cadFile.cadFileName : null,
      });
      await this.loadCart(config);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async saveData() {

    return apiClient.post("orders/" + this.props.formTypeId,
      null
    );
  }

  async loadCart(config) {
    let orderCart = (await apiClient.get("cart/" + this.props.formTypeId,
      config
    )).data;
    orderCart.map(oc => {
      if (oc.name == "From Cast") {
        oc.name = "Create Electronic Shape";
      }
    })

    this.setState({ cart: orderCart });
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
       return (
      <>
        <div
          className={`reviewWrapper ${
            this.props.isBilateral ? "bilateralWrapper" : ""
          }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.name}
                  {this.props.isBilateral &&
                    " (Order " + this.props.orderNumber + ")"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  {this.state.soNumber &&
                      <div className="po">
                        <span>SO Number:</span>
                        <p>{this.state.soNumber}</p>
                      </div>
                    }
                  <div className="po">
                    <span>SSD:</span>
                    <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <h3>Patient Information</h3>
              <div className="patientInfo">
                <div className="infoBorder">
                  <div className="patientSubInfo">
                    <span>Patient ID:</span>
                    <p>{this.state.patientId}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Weight:</span>
                    <p>{this.state.weight}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Height:</span>
                    <p>{this.state.height}</p>
                  </div>
                  
                  <div className="patientSubInfo">
                    <span>K Level</span>
                    <p>{this.state.kLevel}</p>
                  </div>
                </div>

                <div className="info">
                  <div className="patientSubInfo">
                    <span>Amputation Level</span>
                    <p>{this.state.amputationLevel}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>Amputation Side</span>
                    <p>{this.state.footDirection}</p>
                  </div>
                  <div className="patientSubInfo">
                    <span>PO#</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="information">
              <div className="subDetail">
                <h3>Product Information</h3>
                <div className="detailWrapper">
                  <div>
                    <div className="detail">
                      <h4>Socket Options</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Socket Add-ons:</span>
                          {this.makeFieldOutput(this.state.socketOption)}
                        </div>
                           {this.state.socketMaterial[0].fieldOptionId !== this.polypropyleneCopolymerSelectedId ? (
                             <div className="content">
                               <span>Finish:</span>
                                {this.makeFieldOutput(this.state.socketFinish)}
                              </div>) : <></>}
                           {this.state.socketFinish &&
                             this.state.socketFinish[0].fieldOptionId ===
                             this.customerSuppliedFabricId ?
                             <div className="content">
                               <span>Fabric Name:</span>
                               <p>
                                 {this.state.customerSuppliedFabric}
                               </p>
                             </div> : <></>}
                         </div>
                       </div>

                    <div className="detail">
                      <h4>Socket Material</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Socket Material:</span>
                          {this.makeFieldOutput(this.state.socketMaterial)}
                        </div>
                        {this.state.cadFileName !== null ? (
                          <div className="content">
                            <span>Filename:</span>
                            <p>{this.state.cadFileName}</p>
                          </div>
                        ) : <></>}
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Insert Material</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Insert Material:</span>
                          {this.makeFieldOutput(this.state.insertMaterial) ===
                            true ? this.noInsertSelected :
                            this.makeFieldOutput(this.state.insertMaterial)}
                        </div>
                      </div>
                    </div>

                    <div className="detail">
                      <h4>Suspension</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Lock:</span>
                          <div>
                            {" "}
                            {this.makeFieldOutput(this.state.lock)}
                            {this.makeConditionalFieldOutput(
                              "Type",
                              this.state.lockType,
                              "stringData"
                            )}
                          </div>
                        </div>
                        {this.state.lock && 
                        this.state.lock[0].fieldOptionId === 
                        this.customerSuppliedLockId ?
                          <div className="content">
                            <span>Lock Name:</span>
                            <p>
                              {this.state.customerSuppliedLock}
                            </p>
                          </div> : <></>}
                        <div className="content">
                          <span>Valve:</span>
                          <div>
                            {this.makeFieldOutput(this.state.valve)}
                            {this.state.valve[0]?.fieldOptionId === 112
                              ? this.makeFieldOutput(
                                "Lyn Valve Option",
                                this.state.lynOption
                              )
                              : null}
                          </div>
                        </div>
                        {this.state.valve && 
                        this.state.valve[0].fieldOptionId === 
                        this.customerSuppliedValveId ?
                          <div className="content">
                            <span>Valve Name:</span>
                            <p>
                              {this.state.customerSuppliedValve}
                            </p>
                          </div> : <></>}
                      </div>
                    </div>
                  </div>

                  <div>
                    {this.state.socketOption.some(opt => opt.fieldOptionName === "Install & Shape TT Foam Cover" && (opt.booleanData ?? true)) //convert nulls to true for backwards compatability with older orders
                       && (
                      this.props.formTypeId === 5 || this.props.formTypeId === 6 ? 
                      <div className="detail">
                        <h4>Measurements</h4> 
                        {this.props.formTypeId === 5 && (
                          <div className="detailContentWrapper">
                            <div className="">
                              <div className="content">
                                <span>MPT to Floor:</span>
                                <p>
                                  {" "}
                                  {this.imageMeasurementEntry(
                                    this.state.mPTToFloor
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Calf to Floor:</span>
                                <p>
                                  {" "}
                                  {this.imageMeasurementEntry(
                                    this.state.calfToFloor
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Largest Calf:</span>
                                <p>
                                  {this.imageMeasurementEntry(
                                    this.state.calfCirc
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Largest Ankle:</span>
                                <p>
                                  {" "}
                                  {this.imageMeasurementEntry(
                                    this.state.ankleCirc
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {this.props.formTypeId === 6 && (
                          <div className="detailContentWrapper">
                            <div className="borderBotom">
                              <div className="content">
                                <span>IT to Floor:</span>
                                <p>
                                  {this.imageMeasurementEntry(
                                    this.state.iTToFloor
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Thigh to Floor:</span>
                                <p>
                                  {this.imageMeasurementEntry(
                                    this.state.thighToFloor
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>KC to Floor:</span>
                                <p>
                                  {this.imageMeasurementEntry(
                                    this.state.kCToFloor
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Calf to Floor:</span>
                                <p>
                                  {this.imageMeasurementEntry(
                                    this.state.calfToFloor
                                  )}
                                </p>
                              </div>
                            </div>

                            <div className="content">
                              <span>Mid Thigh:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.thighCirc
                                )}
                              </p>
                            </div>

                            <div className="content">
                              <span>KC:</span>
                              <p>
                                {this.imageMeasurementEntry(this.state.kCCirc)}
                              </p>
                            </div>

                            <div className="content">
                              <span>Largest Calf:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.calfCirc
                                )}
                              </p>
                            </div>

                            <div className="content">
                              <span>Largest Ankle:</span>
                              <p>
                                {this.imageMeasurementEntry(
                                  this.state.ankleCirc
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                      </div> : <></>
                    )}
                    <div className="detail">
                      <h4>Mounting Plates</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>Material:</span>
                            {" "}
                            {this.makeFieldOutput(this.state.mountingPlate)}
                        </div>
                        {this.state.mountingPlate && 
                        this.state.mountingPlate[0].fieldOptionId === 
                        this.customerSuppliedPlateId ?
                          <div className="content">
                            <span>Material Name:</span>
                            <p>
                              {this.state.customerSuppliedPlate}
                            </p>
                          </div> : <></>}
                      </div>
                    </div>

                    { this.state.revoFitEnabled &&
                      <div className="detail">
                      <h4>RevoFit®</h4>
                      <div className="detailContentWrapper">
                        <div className="content">
                          <span>RevoFit®:</span>
                            {" "}
                            {this.makeFieldOutput(this.state.revoFit)}
                            {this.makeConditionalFieldOutput(
                              "Additional Window Quantity",
                              this.state.additionalWindowQuantity,
                              "numericData"
                            )}
                        </div>
                      </div>
                      </div>
                    }

                       <div className="detail">
                         <h4>Prosthetic Height Adjustment</h4>
                         <div className="detailContentWrapper">
                           <div style={{ gap: "2px" }} className="content">
                             {this.state.prostheticHeight.length > 0 &&
                               this.state.prostheticHeight[0].fieldOptionId !==
                               this.transferAsIsId ? (
                               <>
                                 <span>{this.state.prostheticHeight[0].fieldOptionName}</span>
                                   {this.makeConditionalFieldOutput(
                                     " Amount",
                                     this.state.shorten,
                                     "numericData",
                                     this.state.prostheticHeightUOM[0].fieldOptionName
                                   )}
                                   {
                                     this.makeConditionalFieldOutput(
                                       " Amount",
                                       this.state.extend,
                                       "numericData",
                                       this.state.prostheticHeightUOM[0].fieldOptionName
                                     )
                                   }
                               </>) : <span>Transfer As Is</span>}
                           </div>
                         </div>
                       </div>
                       <div className="detail">
                         <h4>Modification</h4>
                         <div className="detailContentWrapper">
                           <div className="content">
                             { this.state.modification.fieldOptionId !==
                               this.nomodificationId ? (
                               <>
                                 {this.makeConditionalModificationFieldOutput(
                                   "Percentage",
                                   this.state.modificationPercentage,
                                   "numericData"
                                 )}
                                 {this.makeConditionalModificationFieldOutput(
                                   "Ply",
                                   this.state.modificationPly,
                                   "numericData"
                                 )}
                               </>) : <>{this.makeFieldOutput(this.state.modification)}<span>No Modification</span></>}
                           </div> 
                         </div>
                       </div>

                  </div>
                </div>
              </div>

              <div className="msgInfo ">
                <h3>Items sent with Order</h3>
                <p>{this.state.itemsSentIn !== "" && this.state.itemsSentIn !== null ? this.state.itemsSentIn : "No Value Entered"}</p>
              </div>

              <div className="msgInfo ">
                <h3>Other Notes</h3>
                <p>{this.state.notes !== "" && this.state.notes !== null ? this.state.notes : "No Value Entered"}</p>
              </div>
            </div>

            {this.state.includeLiner && this.state.linerQuantity > 0 && (
              <div className="information">
                <h3>Liner Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Interface:</span>
                      <p>{this.state.linerInterface}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Profile:</span>
                      <p>{this.state.linerProfile}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Size:</span>
                      <p>{this.state.linerSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.linerPartNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Quantity:</span>
                      <p>{this.state.linerQuantity}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.state.includeFoot && (
              <div className="information">
                <h3>Foot Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Type:</span>
                      <p>{this.state.footType}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Material:</span>
                      <p>{this.state.footMaterial}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Impact Level:</span>
                      <p>{this.state.footImpact}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Foot Shell:</span>
                      <p>{this.state.footShell}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.footPartNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!this.props.showOrderInfo && (
              <div className="information">
                <h3>Customer Information</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Bill to account:</span>
                      <p>{this.state.accountNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinic:</span>
                      <p>{this.state.clinicName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinician Name:</span>
                      <p>{this.state.prosthetistName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Email Address</span>
                      <p>{this.state.email}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Phone</span>
                      <p>{this.state.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom">
                    <div className="patientSubInfo">
                      <span>Shipping Address:</span>
                      <p>{this.state.shippingAddress1}</p>
                      <p>{this.state.shippingAddress2}</p>
                      <p>{this.state.city}, {this.state.stateName}</p>
                      <p>{this.state.zip}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.cart.length > 0 ? (
              <div className="information">
                <div className="mb-3"><h3>Cart</h3></div>
                <div className="patientInfo">
                  <div className="cartSubInfo">
                    <table className="transparent-table table">
                      <thead>
                        <tr>
                          <th><span><b>Name</b></span></th>
                          <th></th>
                          <th><span><b>Part Number</b></span></th>
                          <th><span><b>Quantity</b></span></th>
                          <th className="text-right"><span><b>Price</b></span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.cart.map(item => {
                          return (
                              <tr key={item.partNumber}>
                                <td lg="6" sm="1">
                                  <div className="content">
                                    <p className="break-spaces">{item.name.trim()}</p>
                                  </div>
                                </td>
                                <td></td>
                                <td>
                                  <p>{item.partNumber}</p>
                                </td>
                                <td>
                                  <p>{item.quantity}</p>
                                </td>
                                <td>
                                  <p className="text-right">${this.formatPrice(item.price)}</p>
                                </td>
                              </tr>
                            )
                        })}
                        <tr>
                          <td>
                            <div>
                              <span><b>Total</b></span>
                            </div>
                          </td>
                          <td colSpan={4}>
                            <p className="text-right">
                              ${this.formatPrice(this.cartTotal(this.state.cart))}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : <></>}

          </div>
        </div>

        {this.getNavButtons(this.props.uniqueId)}
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }
  
    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
  
}


export default DefinitiveReview;